import React, { useEffect, useRef, useState } from 'react';

export default function useNumericField(
    committed: number,
    isValid: (n: number) => boolean,
    onCommit: (n: number) => void
) {
    const [input, setInput] = useState(String(committed));
    const lastCommitted = useRef(committed);

    useEffect(() => {
        if (committed !== lastCommitted.current) {
            setInput(String(committed));
            lastCommitted.current = committed;
        }
    }, [committed]);

    function onChange(e: React.ChangeEvent<HTMLInputElement>) {
        const raw = e.target.value;
        setInput(raw);
        const n = Number(raw);
        if (raw.trim() === '' || Number.isNaN(n) || !isValid(n)) return;
        const rounded = Math.round(n * 100) / 100;
        lastCommitted.current = rounded;
        onCommit(rounded);
    }

    return { input, onChange };
}
